import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useBusinessActivityList } from "Hooks/Options/useBusinessActivityList";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
  disabled?: boolean;
  includeLegacy?: boolean;
};

export const BusinessActivityDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  disabled,
  includeLegacy,
}: Props<T, V>) => {
  const codeList = useBusinessActivityList({ includeLegacy });

  return (
    <Dropdown
      codeList={codeList}
      name={name}
      control={control}
      label={label}
      disabled={disabled}
    />
  );
};
